import React from 'react';
import { TextInput, SelectInput, ReferenceInput, AutocompleteInput, BooleanInput } from 'react-admin';
import PeriodInput from '../../app/periodInput.component';
import { ALL_ORGANIZATIONS_RESOURCE_NAME as ORGANIZATIONS_RESOURCE } from '../../organizations/organizations.dataProvider';
import { LeadStatusChoices } from '../leads.model';

// Define consistent styles for all filter inputs
const commonInputStyles = {
  marginBottom: 0,
  width: '100%',
  minWidth: 180,
  marginRight: 16
};

export const leadFilters = [
  <TextInput
    source="q"
    label="Search (name, email)"
    alwaysOn
    size="small"
    sx={commonInputStyles}
    className="filter-field"
  />,
  <SelectInput
    source="status"
    label="Status"
    choices={LeadStatusChoices}
    size="small"
    sx={commonInputStyles}
    className="filter-field"
  />,
  <BooleanInput
    source="includeArchived"
    label="Include archived"
    alwaysOn
    size="small"
    sx={commonInputStyles}
    className="filter-field"
  />,
  <TextInput
    source="importBatchId"
    label="Batch ID"
    size="small"
    sx={commonInputStyles}
    className="filter-field"
  />,
  <ReferenceInput
    label="Source Organization"
    source="source_org_id"
    reference={ORGANIZATIONS_RESOURCE}
    perPage={10000}
    sort={{ field: 'name', order: 'ASC' }}
    sx={commonInputStyles}
    className="filter-field"
  >
    <AutocompleteInput
      optionText="name"
      size="small"
      sx={{ minWidth: 180 }}
    />
  </ReferenceInput>,
  <PeriodInput
    source="createdBetween"
    fromLabel="Created From"
    toLabel="Created To"
    label="Created Date"
    size="small"
    sx={commonInputStyles}
    className="filter-field"
  />,
];

export default leadFilters;
